import { apiBase, createClient, tokenStore, type CertificateTemplate, type PaymentMethod, type PublicTenant } from '@ck/sdk';

export const session = tokenStore('ck.staff.session');

let onSignedOut: () => void = () => undefined;
export const setSignedOutHandler = (fn: () => void) => { onSignedOut = fn; };

export const api = createClient({
  baseUrl: apiBase(import.meta.env.VITE_API_URL),
  tenant: import.meta.env.VITE_TENANT || undefined,
  token: () => session.get(),
  onUnauthorized: () => { session.set(null); onSignedOut(); },
});

/** Every CRM call goes under /v1/admin. */
export const A = (path: string) => `/v1/admin${path}`;

export interface Settings { paymentMethods: PaymentMethod[]; partnerCommissionPct: number; partnerMinPayoutUsd: number; security?: SecuritySettings; maintenance?: { on: boolean; message: string }; certificate?: CertificateTemplate }
export type StaffTenant = PublicTenant & { settings: Settings };
export interface Staff { avatarUrl?: string | null; id: string; name: string; email: string; role: string; department?: string; totpEnabled: boolean; permissions: string[]; isHead?: boolean; internDept?: string | null; supervises?: number }
export const me = () => api.get<{ staff: Staff; tenant: StaffTenant }>(A('/me'));
export interface SecuritySettings { require2fa: boolean; ipAllowlist: string[]; sessionMinutes: number }

/** Absolute address of a photo path the API returns (e.g. /v1/avatars/…). */
export const photoUrl = (p?: string | null) => (p ? `${apiBase(import.meta.env.VITE_API_URL).replace(/\/$/, '')}${p}` : null);
export const API_ROOT = apiBase(import.meta.env.VITE_API_URL).replace(/\/$/, '');
